import { Box, Divider, Stack, Typography } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid-pro';
import { FormatCurrency } from '@vestwell-frontend/ui';

import Decimal from 'decimal.js';
import { FC } from 'react';

export const ContributionRowDetails: FC<GridRowParams> = props => {
  if (!props.row?.contributionMeta?.ucid) return;

  return (
    <Box display='flex' gap={4} p={4}>
      <Stack display='flex' flex={1} justifyContent='space-between'>
        <Stack>
          <Stack
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            py={1}>
            <Typography color='gray' fontWeight='bold'>
              Employee Contribution
            </Typography>
            <Typography fontWeight='bold'>
              <FormatCurrency
                precision={2}
                showPlaceholder={false}
                value={Decimal.sum(
                  props.row?.totals?.totalSd ?? 0,
                  props.row?.totals?.totalRc ?? 0,
                  props.row?.totals?.totalAt ?? 0
                ).toNumber()}
              />
            </Typography>
          </Stack>
          <Stack
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            py={1}>
            <Typography color='gray'>Roth</Typography>
            <Typography>
              <FormatCurrency
                precision={2}
                showPlaceholder={false}
                value={props.row?.totals?.totalRc ?? 0}
              />
            </Typography>
          </Stack>
          <Stack
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            py={1}>
            <Typography color='gray'>Pre-Tax</Typography>
            <Typography>
              <FormatCurrency
                precision={2}
                showPlaceholder={false}
                value={props.row?.totals?.totalSd ?? 0}
              />
            </Typography>
          </Stack>
          <Stack
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            py={1}>
            <Typography color='gray'>After Tax</Typography>
            <Typography>
              <FormatCurrency
                precision={2}
                showPlaceholder={false}
                value={props.row?.totals?.totalAt ?? 0}
              />
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <Stack
            display='flex'
            flexDirection='row'
            justifyContent='space-between'
            py={1}>
            <Typography color='gray' fontWeight='bold'>
              Loan Payment
            </Typography>
            <Typography fontWeight='bold'>
              <FormatCurrency
                precision={2}
                showPlaceholder={false}
                value={props.row?.totals?.totalLn ?? 0}
              />
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Divider flexItem orientation='vertical' />

      <Stack flex={1}>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray' fontWeight='bold'>
            Employer Contribution
          </Typography>
          <Typography fontWeight='bold'>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={Decimal.sum(
                props.row?.totals?.totalEm ?? 0,
                props.row?.totals?.totalSh ?? 0,
                props.row?.totals?.totalPs ?? 0,
                props.row?.totals?.totalPw ?? 0,
                props.row?.totals?.totalQc ?? 0
              ).toNumber()}
            />
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Match</Typography>
          <Typography>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={props.row?.totals?.totalEm ?? 0}
            />
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Profit Sharing</Typography>
          <Typography>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={props.row?.totals?.totalPs ?? 0}
            />
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>QNEC</Typography>
          <Typography>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={props.row?.totals?.totalQc ?? 0}
            />
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Safe Harbor</Typography>
          <Typography>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={props.row?.totals?.totalSh ?? 0}
            />
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Prevailing Wage</Typography>
          <Typography>
            <FormatCurrency
              precision={2}
              showPlaceholder={false}
              value={props.row?.totals?.totalPw ?? 0}
            />
          </Typography>
        </Stack>
      </Stack>

      <Divider flexItem orientation='vertical' />

      <Stack flex={1}>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Initiated Date</Typography>
          <Typography>
            {props.row?.contributionMeta?.payrollStartedDate ?? '--'}
          </Typography>
        </Stack>
        <Stack
          display='flex'
          flexDirection='row'
          justifyContent='space-between'
          py={1}>
          <Typography color='gray'>Initiator</Typography>
          <Typography>
            {' '}
            {props.row?.contributionMeta?.initiator ?? '--'}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
